import React from 'react';
import {
    Paper,
    List,
    ListItemButton,
    ListItemText,
    RadioGroup,
    FormControlLabel,
    Radio,
    Grid, Chip
} from '@mui/material';
import { useTheme } from '@mui/material/styles';

function TemplateEquipment({
    gearBySlot,
    handleItemClick,
    selectedItem,
    weaponConfig,
    setWeaponConfig,
    hoveredSlot,
    setHoveredSlot,
    hoveredMetric,
    highlightedSlots = []
}) {
    const theme = useTheme();
    const primaryColor = theme.palette.primary.main;
    const gearSlots = ['Torso', 'Helm', 'Arms', 'Hands', 'Legs', 'Feet', 'Necklace', 'Cloak', 'Jewel', 'Belt', 'L Ring', 'R Ring', 'L Wrist', 'R Wrist', 'Mythirian', 'Main Hand', 'Off Hand', 'Two-Hand', 'Ranged'];

    const selectedStyle = {
        boxShadow: `inset 0 0 0 4px ${primaryColor}`,
        backgroundColor: 'transparent'
    };

    const getContributionLabels = (slot) => {
        const sources = hoveredMetric?.sources?.filter(source => source.slot === slot) || [];
        if (!sources.length) return [];

        const totalsByBucket = sources.reduce((totals, source) => {
            const bucket = source.bucket || 'value';
            totals[bucket] = (totals[bucket] || 0) + source.value;
            return totals;
        }, {});

        const bucketLabels = {
            value: '',
            cap: 'cap',
            mythicalCap: 'myth',
            ability: ''
        };

        return Object.entries(totalsByBucket).map(([bucket, value]) => {
            const sign = value >= 0 ? '+' : '';
            const label = bucketLabels[bucket] ? ` ${bucketLabels[bucket]}` : '';
            return `${sign}${value}${label}`;
        });
    };

    return (
        <Paper style={{ padding: '8px', flex: 1 }}>
            <RadioGroup row value={weaponConfig} onChange={(event) => setWeaponConfig(event.target.value)} style={{ marginBottom: '8px' }}>
                <FormControlLabel value="Main Hand / Off Hand" control={<Radio size="small" />} label="MH / OH" />
                <FormControlLabel value="Two-Hand" control={<Radio size="small" />} label="Two-Hand" />
                <FormControlLabel value="Ranged" control={<Radio size="small" />} label="Ranged" />
                <FormControlLabel value="Weaponless" control={<Radio size="small" />} label="Weaponless" />
            </RadioGroup>
            <List component="nav" dense>
                {gearSlots.map(slot => {
                    const isHighlighted = highlightedSlots.includes(slot);
                    const isHovered = hoveredSlot === slot;
                    const contributionLabels = getContributionLabels(slot);

                    return (
                        <ListItemButton
                            key={slot}
                            selected={selectedItem === slot}
                            style={{
                                ...(selectedItem === slot ? selectedStyle : {}),
                                padding: '4px 8px',
                                backgroundColor: isHighlighted || isHovered ? theme.palette.action.hover : undefined,
                                boxShadow: isHighlighted && selectedItem !== slot ? `inset 0 0 0 2px ${primaryColor}` : selectedItem === slot ? selectedStyle.boxShadow : undefined
                            }}
                            onClick={() => handleItemClick(slot)}
                            onMouseEnter={() => setHoveredSlot?.(slot)}
                            onMouseLeave={() => setHoveredSlot?.(null)}
                        >
                            <Grid container alignItems="center" justifyContent="space-between" spacing={1}>
                                <Grid item xs>
                                    <ListItemText
                                        primary={
                                            <React.Fragment>
                                                <Chip
                                                    label={slot}
                                                    variant={isHighlighted ? "filled" : "outlined"}
                                                    size="small"
                                                    color={isHighlighted ? "primary" : "default"}
                                                    style={{ marginRight: '8px', width: '80px' }}
                                                />
                                                <span style={{ color: primaryColor }}>{gearBySlot[slot]?.name || ''}</span>
                                                {contributionLabels.map(label => (
                                                    <Chip
                                                        key={`${slot}-${label}`}
                                                        label={label}
                                                        color="secondary"
                                                        size="small"
                                                        variant="outlined"
                                                        style={{ marginLeft: '6px', height: '20px' }}
                                                    />
                                                ))}
                                            </React.Fragment>
                                        }
                                        primaryTypographyProps={{ style: { fontSize: '0.9rem' } }}
                                    />
                                </Grid>
                            </Grid>
                        </ListItemButton>
                    );
                })}
            </List>
        </Paper>
    );
}

export default TemplateEquipment;
